import {Routes,Route} from 'react-router-dom'
import Home from './screens/Home';
import Contact from './screens/Contact';
import About from './screens/About';
import Policy from './screens/Policy';
import Pagenotfound from './screens/Pagenotfound';
import Login from './screens/Login';
import Admin from './screens/Admin';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/contact' element={<Contact/>} />
      <Route path='/about' element={<About/>} />
      <Route path='/policy' element={<Policy/>} />
      <Route path='/login' element={<Login/>}/>
      <Route path='' element={<PrivateRoute/>}>
        <Route path='/admin' element={<Admin/>}/>
      </Route>
      <Route path='/*' element={<Pagenotfound/>} />
    </Routes>
  );
}

export default App;
